import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Account(props) {

  const navigate = useNavigate();
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  const [saveDisabled, setSaveDisabled] = useState(false);

  const [error, setError] = useState('');

  const [email, setEmail] = useState('');

  const [phone, setPhone] = useState('');
  const [phoneExtraClasses, setPhoneExtraClasses] = useState('');
  const [phoneError, setPhoneError] = useState('');

  const [name, setName] = useState('');
  const [nameExtraClasses, setNameExtraClasses] = useState('');
  const [nameError, setNameError] = useState('');

  const [currentPassword, setCurrentPassword] = useState('');
  const [currentPasswordExtraClasses, setCurrentPasswordExtraClasses] = useState('');
  const [currentPasswordError, setCurrentPasswordError] = useState('');

  const [newPassword, setNewPassword] = useState('');
  const [newPasswordExtraClasses, setNewPasswordExtraClasses] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');

  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [confirmNewPasswordExtraClasses, setConfirmNewPasswordExtraClasses] = useState('');
  const [confirmNewPasswordError, setConfirmNewPasswordError] = useState('');

  // the backend won't return any errors for 
  const [coverage, setCoverage] = useState('');

  const [showOnMap, setShowOnMap] = useState(true)

  // business name and phone are just contrained my maxLength and the backend trims it
  const [businessName, setBusinessName] = useState(null)
  const [businessPhone, setBusinessPhone] = useState(null)

  const [businessEmail, setBusinessEmail] = useState(null)
  const [businessEmailExtraClasses, setBusinessEmailExtraClasses] = useState('')
  const [businessEmailError, setBusinessEmailError] = useState('')

  const applySettings = (event) => {
    event.preventDefault();
  }

  const goHome = () => {
    navigate('/home');
  }

  const doSaveSettings = (event) => {
    event.preventDefault();
    setError('Working...');

    setNameExtraClasses('');
    setNameError('');
    setPhoneExtraClasses('');
    setPhoneError('');

    setCurrentPasswordExtraClasses('');
    setCurrentPasswordError('');
    setNewPasswordExtraClasses('');
    setNewPasswordError('');

    setBusinessEmailExtraClasses('')
    setBusinessEmailError('')

    const url = process.env.REACT_APP_API_END_POINT + 'account/';
    
    fetch(url,
      {
        headers: {
          'Accept': 'application/json',
        },
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          name,
          phone,
          currentPassword,
          newPassword,
          coverage,
          showOnMap,
          businessEmail,
          businessPhone,
          businessName
        })
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['success']) {
          goHome();
        } else {
          if ('errors' in data) {
            data.errors.forEach(err => {
              if (err.key === 'name') {
                setNameExtraClasses('is-invalid');
                setNameError(err.error);
              }
              if (err.key === 'phone') {
                setPhoneExtraClasses('is-invalid')
                setPhoneError(err.error)
              }
              if (err.key === 'currentPassword') {
                setCurrentPasswordExtraClasses('is-invalid')
                setCurrentPasswordError(err.error)
              }
              if (err.key === 'newPassword') {
                setNewPasswordExtraClasses('is-invalid')
                setNewPasswordError(err.error)
              }
              if (err.key === 'businessEmail') {
                setBusinessEmailExtraClasses('is-invalid')
                setBusinessEmailError(err.error)
              }
              setError('Please correct errors and try again.')
            });
          } else {
            setError(data['error'])
          }
        }
      });
    
  }

  useEffect(() => {
    const url = process.env.REACT_APP_API_END_POINT + 'account/';

    fetch(url, 
      {
        headers: {
          'Accept': 'application/json',
        },
        method: "GET",
        credentials: "include"
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['success']) {
          setSettingsLoaded(true)
          // depending on when the user was created the settings may not exist or even be set
          var settings = data['settings']
          setEmail(settings['email'])
          setPhone(settings['phone'])
          setName(settings['name'])
          setCoverage(settings['coverage'])
          setShowOnMap(settings['showOnMap'])
          setBusinessName(settings['businessName'])
          setBusinessEmail(settings['businessEmail'])
          setBusinessPhone(settings['businessPhone'])
        } else {
          navigate('/')
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSaveDisabled(false);
    setConfirmNewPasswordExtraClasses('');
    setConfirmNewPasswordError('');
    if (newPassword !== '' || confirmNewPassword !== '') {
      if (newPassword !== confirmNewPassword) {
        setConfirmNewPasswordExtraClasses('is-invalid');
        setConfirmNewPasswordError("Dose not match");
        setSaveDisabled(true);
      }
    }
  }, [newPassword, confirmNewPassword]);

  return (
    <>
      <div className="contentsAreaHeader">
        <div className="areaTitle">My Account</div>
        <div className="areaExplainer">Set your personal data and how you access your account</div>
      </div>
      <div className="contents">
        <div style={{width: "600px", maxWidth: "100%"}}>

          { !settingsLoaded ? <div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div> : 
          
            <form onSubmit={applySettings}>

              <div className="form-group pb-2">
                <label htmlFor="emailInput"><strong>Email</strong></label>
                <input id="emailInput" className="form-control" type="text" value={email} disabled />
                <small id="emailHelp" className="form-text text-muted">Please contact support if you need to change your email address.</small>
              </div>

              <div className="form-group pb-2">
                <label htmlFor="nameInput"><strong>Full name</strong></label>
                <input id="nameInput" className={"form-control " + nameExtraClasses} type="text" placeholder="Joe Bloggs" value={name} onChange={(e) => setName(e.target.value)} aria-describedby='validationName' />
                <div id="validationName" className="invalid-feedback">{nameError}</div>
                <small id="nameHelp" className="form-text text-muted">So that we know what to call you if we need to get in touch.</small>
              </div>

              <div className="form-group pb-2">
                <label htmlFor="phoneInput"><strong>Phone</strong></label>
                <input id="phoneInput" className={"form-control " + phoneExtraClasses} type="text" placeholder="01234 567890" value={phone} onChange={(e) => setPhone(e.target.value)} aria-describedby='validationPhone' />
                <div id="validationPhone" className="invalid-feedback">{phoneError}</div>
                <small id="phoneHelp" className="form-text text-muted">In case we need to get in touch.</small>
              </div>
              {!(props.userRole === 'surveyor' || props.userRole === 'ra') && <>
                <div className="form-group pb-2">
                  <label htmlFor="businessNameInput"><strong>Business name</strong></label>
                  <input id="businessNameInput" className="form-control" type="text" placeholder="Example Ltd" value={businessName} onChange={(e) => setBusinessName(e.target.value)} />
                </div>
              </>}
              {(props.userRole === 'surveyor' || props.userRole === 'ra') && <>
                <p className="pt-3"><strong>EPC areas covered</strong></p>
                <div className="form-group pb-2">
                  <label htmlFor="coverageInput">Sometimes we recieve requests for EPC surveys and we like to pass these on to assessors registered on our platform. Please briefly describe the areas you cover:</label>
                  <textarea
                    id="coverageInput"
                    className={"form-control"}
                    style={{height: "200px"}}
                    value={coverage}
                    onChange={e => setCoverage(e.target.value)}
                    placeholder={"e.g: 'Manchester'\n'DE1, DE2, DE4-7'\n'North Lancashire'\nor 'Within M25'"}
                  />
                  <p>{coverage.length} / max 1000 characters</p>
                </div>

                <p className="pt-3"><strong>Include on epims.co.uk map</strong></p>
                <div className="form-group pb-2">
                  <input id="showOnMap" type="checkbox" style={{marginRight: "10px"}} checked={showOnMap} onChange={e => setShowOnMap(e.target.checked)}/><label htmlFor="showOnMap">Show my business on the public epims.co.uk homepage map</label>
                </div>

                <p className="pt-3"><strong>Business details to show on map</strong></p>
                <p>Changes to map information will go live after review by our team</p>
                <div className="form-group pb-2">
                  <div style={{display: "grid", gridTemplateColumns: "120px 300px", rowGap: "10px"}}>
                    <div style={{paddingTop: "5px"}}>Business name:</div>
                    <div><input className="form-control" style={{width: "290px"}} value={businessName} maxLength="200" disabled={!showOnMap} onChange={e => setBusinessName(e.target.value)} /></div>
                  </div>
                </div>
                <div className="form-group pb-2">
                  <div style={{display: "grid", gridTemplateColumns: "120px 300px", rowGap: "10px"}}>
                    <div style={{paddingTop: "5px"}}>Phone:</div>
                    <div><input className="form-control" style={{width: "290px"}} value={businessPhone} maxLength="200" disabled={!showOnMap} onChange={e => setBusinessPhone(e.target.value)} /></div>
                  </div>
                </div>
                <div className="form-group pb-2">
                  <div style={{display: "grid", gridTemplateColumns: "120px 300px", rowGap: "10px"}}>
                    <div style={{paddingTop: "5px"}}>Email:</div>
                    <div>
                      <input className={"form-control " + businessEmailExtraClasses} style={{width: "290px"}} value={businessEmail} maxLength="200" disabled={!showOnMap} onChange={e => setBusinessEmail(e.target.value)} aria-describedby='validationBusinessEmail' />
                      <div id="validationBusinessEmail" className="invalid-feedback">{businessEmailError}</div>
                    </div>
                  </div>
                </div>
              </>}

              <p className="pt-3" style={{marginBottom: "6px"}}><strong>Change password</strong></p>
              <div className="form-group">
                <label htmlFor="currentPasswordInput">To update your password, please provide your current password</label>
                <input id="currentPasswordInput" className={"form-control " + currentPasswordExtraClasses} type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} aria-describedby='validationCurrentPassword' />
                <div id="validationCurrentPassword" className="invalid-feedback">{currentPasswordError}</div>
              </div>
              <div className="form-group">
                <label htmlFor="newPasswordInput">New password</label>
                <input id="newPasswordInput" className={"form-control " + newPasswordExtraClasses} type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} aria-describedby='validationNewPassword' />
                <div id="validationNewPassword" className="invalid-feedback">{newPasswordError}</div>
                <small id="newPasswordHelp" className="form-text text-muted">Must be at least 8 characters and contain at least one number or symbol.</small>
              </div>
              <div className="form-group pb-3">
                <label htmlFor="confirmNewPasswordInput">Confirm new password</label>
                <input id="confirmNewPasswordInput" className={"form-control " + confirmNewPasswordExtraClasses} type="password" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} aria-describedby='validationConfirmNewPassword' />
                <div id="validationConfirmNewPassword" className="invalid-feedback">{confirmNewPasswordError}</div>
              </div>

              <div className="form-group pt-3">
                <button type="submit" onClick={doSaveSettings} className="btn btn-primary btn-sm" disabled={saveDisabled}>Save</button>
                &nbsp;
                <button type="button" onClick={goHome} className="btn btn-secondary btn-sm">Cancel</button>&nbsp;{error}
              </div>

            </form>
          }
        </div>
      </div>
    </>
  );

}

export default Account;
